export default function () {
  const widgetName = 'cardWidgetEvent';
  const widgetOpts = cardWidgetEventOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
		const arr = data.items;		
		for(let i=0; i< arr.length; i++){
		    if(!arr[i].DateRange){
		       // console.log('Date value is empty!');
		    }
		    else {
		        arr[i].Description = arr[i].Title
		        arr[i].Title = arr[i].DateRange;
		    }
		}

		$('#cardWidgetEvent .card-content').each(function(index, element){ 
			$(this).find($('span.card-widget-title')).html(arr[index].Title);
			$(this).find('.card-widget-description').html(arr[index].Description);
		}); // end
		 
		$('#cardWidgetEvent .card-content').each(function () {
			var eventDate = $(this).find($('span.card-widget-title'));
			var datesMonth = eventDate.text().slice(0, 3);
			var datesDay = eventDate.text().slice(4, 7).replace(',', '');
			eventDate.text(datesMonth);
			eventDate.append("<span>" + datesDay + "</span>");
			const itemTitle = $(this).find('.card-widget-description');
			const characterLimit = 60;
			const itemTitleText = itemTitle.text();
			if (itemTitleText.length > characterLimit) {
			  const trimmedText = itemTitleText.substring(0, characterLimit) + '...';
			  itemTitle.text(trimmedText);
			}
		}); // end

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: true
  });
  
  

}